import DetailedTimeSelectingModal from './DetailedTimeSelectingModal';
import DoubleTimeSelectingModal from './DoubleTimeSelectingModal';

export const TimeSelectingModal = {
  Double: DoubleTimeSelectingModal,
  Detailed: DetailedTimeSelectingModal,
};
